// Base URLs
export const BASE = process.env?.VITE_BASE_URL;
export const BASE_REACT_URL = 'http://localhost:3000';
export const DOMAIN = 'nurale.com';
export const API = '/api';
export const V1 = '/v1';

export const AUTH = '/auth';
export const URL_LOGIN = '/login';
export const URL_REFRESH = '/refresh-token';
export const FORGET_PASSWORD = '/forget-password';
export const URL_RESET_PASSWORD = '/reset-password';
export const ME = '/me';
export const URL_USERS = '/users';
export const URL_INVOICING_CONFIG = '/invoicing/config';
